import React from "react";

const SiteMap = ({ menuItems = [] }) => {
  return (
    <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
      <h2 className="text-3xl text-indian-red font-heading font-bold mt-16 text-center">Sitemap</h2>
<div className="relative flex items-center justify-center  line-with-image">
            <img src="/assets/SHIKSHA_Flower_SVG.svg" alt="headingflower" className="h-7 sm:h-6 lg:h-9 bg-white p-1 sm:p-2" />
          </div>

      {/* Mobile View - Vertical Flow */}
      <div className="block md:hidden">
        <div className="flex flex-col relative border-l-2 border-gray-300 pl-6">

          {/* Home Node */}
          <div className="relative mb-6">
            <div className="absolute -left-0.5 top-3 h-[1px] w-4 bg-indian-red">
            <a
              href="/"
              className="text-warm-orange font-semibold text-lg hover:underline pl-6"
            >
              Home
            </a>
            </div>
          </div>

          {/* Menu Items */}
          {menuItems.map((menuItem, index) => (
            <div key={index} className="relative mb-6">
              {/* Line from vertical bar to node */}
              <div className="absolute -left-0.5 top-3 h-[1px] w-4 bg-gray-500"></div>

              {menuItem.children.length > 0 ? (
                <div>
                  <div className="text-gray-800 font-bold text-lg pl-6">
                    {menuItem.title}
                  </div>
                  <div className="ml-6 mt-2 flex flex-col gap-2 border-l-2 border-gray-200 pl-4">
                    {menuItem.children.map((child, childIndex) => (
                      <div key={childIndex} className="relative">
                        <div className="absolute -left-4 top-2 h-[1px] w-4 bg-gray-400"></div>
                        <a
                          href={child.url}
                          className="text-gray-700 text-sm hover:underline"
                        >
                          {child.title}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <a
                  href={menuItem.url}
                  className="text-black font-bold text-lg hover:underline pl-6"
                >
                  {menuItem.title}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Desktop View - Table Layout */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-center">
          <thead>
            <tr>
              <th colSpan={menuItems.length} className="p-4">
                {/* <div className="relative mb-6 pl-6"> */}
                  {/* Connector line from vertical bar */}
                  <div className="absolute -left-0.5 top-1/2 transform -translate-y-1/2 h-[1px] w-4 bg-navy-blue"></div>

                  {/* Small clickable blue box */}
                  <a
                    href="/"
                    className="inline-block text-indian-red  font-body bg-warm-orange font-bold text-lg px-4 py-2 rounded-md shadow-md hover:underline transition"
                  >
                    Home
                  </a>
                {/* </div> */}


              </th>
            </tr>
            <tr>
              {menuItems.map((menuItem, index) => (
                <th key={index} className="p-4">
                  <div className="bg-indian-red text-white font-body hover:underline font-semibold p-3 rounded-lg shadow-md min-w-[160px] text-lg">
                    {menuItem.children.length > 0 ? (
                      <span>{menuItem.title}</span>
                    ) : (
                      <a href={menuItem.url} className="text-white hover:underline">
                        {menuItem.title}
                      </a>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {menuItems.map((menuItem, index) => (
                <td key={index} className="p-4 align-top">
                  {menuItem.children.length > 0 ? (
                    <div className="flex flex-col items-center gap-2">
                      {menuItem.children.map((child, childIndex) => (
                        <a
                          key={childIndex}
                          href={child.url}
                          className="bg-warm-orange font-body p-3 rounded-lg shadow text-indian-red hover:underline block min-w-[140px] text-lg transition"
                        >
                          {child.title}
                        </a>
                      ))}
                    </div>
                  ) : (
                    <span className="text-white text-sm"></span>
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SiteMap;
